import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2gyr9m38qj: FaireBrandEntity = {
  token: "b_2gyr9m38qj",
  type: "brand",
  name: "Trefl USA",
  avatarUrl:
    "https://cdn.faire.com/fastly/e0aa725ae711e22c8c97ef7802bf571a8f6c40ec27d27cab21182e656a313c05.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/16e5ace58d9e275aa27fe026890d9cac64e40415a9dae5fca1280b44c7b3fa0c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e0aa725ae711e22c8c97ef7802bf571a8f6c40ec27d27cab21182e656a313c05.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/16e5ace58d9e275aa27fe026890d9cac64e40415a9dae5fca1280b44c7b3fa0c.png",
  location: "St Petersburg, FL, USA",
  minimumOrderDollars: 170,
  rating: 4.8,
  reviewCount: 9,
  isTopShop: true,
  isInsider: true,
  description:
    "We want our toys and productions to bring ideas to spend time together in an interesting way and to support cognition and understanding of the surrounding world, with the entertainment we offer to connect and bring people together by sharing emotions. From the very beginning, our aim has been to provide valuable and developing entertainment for whole families. Hence why everything we do is created with the needs of our audience in mind - that is, children, teenagers, and parents.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:05.717Z",
    importedBy: "entity-db-cli",
  },
};
